module.exports = __webpack_public_path__ + "static/media/ic_no_client_images.05c5e26d.png";